<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0006 5.33337V5.33761M8.00062 5.33337V5.33761M4.00061 5.33337V5.33761M12.0006 10.6625V10.6667M8.00062 10.6625V10.6667M4.00061 10.6625V10.6667"
      stroke="#1C1C1C"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'DragAndDrop',
  props: {
    size: {
      type: String,
      default: '16',
    },
  },
}
</script>
